import { scrollAnimataion } from './scroll-animataion/scroll-animataion.js';
import { markerSet } from './marker-set/marker-set.js';
import { fadeJudge } from './to-top-btn-fade/to-top-btn-fade.js';


// ===========================================
// 中見出しのインタラクション
// ===========================================
$(function () {
  markerSet( $('.campaignDetail') );

  $(window).on('scroll', function(){
    markerSet( $('.campaignDetail') );
  });
});


// ===========================================
// 動画のモーダルのインタラクション
// ===========================================
$(function () {
  $('.campaignMovie__tmb').each(function(){
    const tmb = $(this),
          modal = $('.movieModal[data-movie-modal="' + tmb.attr('data-movie-modal') + '"]'),
          shadow = modal.find('.movieModalShadow'),
          close = modal.find('.movieModalClose'),
          html = modal.find('.movieModal__box').html();

    tmb.on('click', function(){
      modal.addClass('on');
      $("html").css({ overflow: "hidden" });
    });

    close.on('click', function(){
      modal.removeClass('on');
      $("html").css({ overflow: "auto" });
      modal.find('iframe, img').remove();
      modal.find('.movieModal__box').prepend( html );
      modal.find('.movieModalClose:nth-child(1)').remove();
    });

    shadow.on('click', function(){
      close.click();
    });
  });
});


// ===========================================
// アコーディオン
// ===========================================
$(function () {
  $('.moreContentsBtn, .moreContentsBtn--white').each(function(){
    const btn = $(this),
          box = btn.next('.moreContents');
    let count = 0;

    btn.on('click', function(){
      count++;

      btn.toggleClass('open').css({ pointerEvents: 'none' });

      if( count % 2 === 0 ) {
        btn.find('.moreContentsTxt').html( btn.find('.moreContentsTxt').attr('data-txt') );
      } else {
        btn.find('.moreContentsTxt').html( '閉じる' );
      }

      box.slideToggle(300);

      setTimeout(function () {
        btn.css({ pointerEvents: 'auto' });
      }, 350);
    });
  });
});


// ===========================================
// テーブルのスクロールバー
// ===========================================
$(function () {
  function scrollSet() {
    $('.tableBlock').each(function(){
      const table = $(this),
            tableHtml = table.html();

      table.after(
        '<div class="tableBlockWrapper"><div class="tableBlockWrapperInner"><table class="tableBlock">' +
          tableHtml +
        '</table></div></div>'
      );
    });

    $('.tableBlockWrapper').each(function(n){
      $(this).addClass( 'tableBlockWrapper--' + n );
    });

    $('.tableBlockWrapper').each(function(n){
      const ps = new PerfectScrollbar( '.tableBlockWrapper--' + n );
    });
  }
  scrollSet();

  $(window).on('resize', function(){
    $('.tableBlockWrapper').remove();

    scrollSet();
  });
});


// ===========================================
// 応募ボタンのインタラクション
// ===========================================
$(function () {
  function fixJudge( area ) {
    let scroll = $(window).scrollTop(),
        fadePoint = $('.t-page').height() + $('.t-page').offset().top;

    if( scroll + $(window).height() > fadePoint ) {
      area.addClass('unfix');
    } else {
      area.removeClass('unfix');
    }
  }

  $('.applyArea').each(function(){
    const area = $(this);

    fixJudge( area );

    $(window).on('scroll', function(){
      fixJudge( area );
    });
  });
});


// ===========================================
// ページ上部へ戻るボタンのインタラクション
// ===========================================
$(function () {
  fadeJudge();
});